/* styles */
import useStyles from "./useStyles"
import { Checkbox, Typography } from "@mui/material"
import { namesTypesTraduc } from "../../../../../utils/traducTypes"
import ModalMenuItemUserSuscriber from "../../Modals/ModalMenuUserOfSuscriber"

function TableItem({
  item,
  id,
  setRows,
  setLoading,
  userTypes,
  setOpenModalDisableUser,
  types,
  typesComercial,
  typesStatus,
}) {
  const classes = useStyles()

  function traducName(code) {
    let name = "- -"
    if (types && types.length > 0) {
      types.map((type) => {
        namesTypesTraduc.map((typeTraduc) => {
          if (
            type.organizationUserTypeCode === typeTraduc.code &&
            type.organizationUserTypeId === code
          ) {
            name = typeTraduc.name
          }
          return name
        })
        return type
      })
    }
    return name
  }

  const getIconStatus = (code) => {
    const type = userTypes.find(
      (element) => element.userStatusId === code,
    )

    if (type) {
      switch (type.userStatusCode) {
        case "ACTIVE":
          return (
            <Typography className={classes.itemStatusActive}>{type.userStatusName}</Typography>
          )
        case "WAITING_VALIDATION":
          return (
            <Typography className={classes.itemStatusWaiting}>
              {type.userStatusName}
            </Typography>
          )
        case "DELETED":
          return (
            <Typography className={classes.itemStatusInactive}>
              {type.userStatusName}
            </Typography>
          )
        case "INACTIVE":
          return (
            <Typography className={classes.itemStatusInactive}>
              {type.userStatusName}
            </Typography>
          )
        // no funciona
        case "SUSPENDED":
          return (
            <Typography className={classes.itemStatusInactive}>
              {type.userStatusName}
            </Typography>
          )

        default:
          return (
            <Typography className={classes.itemStatusActive}>-</Typography>
          )
      }
    }
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemCheck}>
          <Checkbox />
        </td>
        <td className={classes.itemIcon}>
          {getIconStatus(item.user_status_id)}
        </td>

        <td className={classes.itemName}>
          {item.login_account.first_name || "- -"}
        </td>
        <td className={classes.itemLastName}>
          {item.login_account.last_name || "- -"}
        </td>
        <td className={classes.itemEmail}>
          {item.login_account.email || "- -"}
        </td>
        <td className={classes.itemTypeUser}>
          {traducName(item.organization_user_type_id) || "- -"}
        </td>

        <td className={classes.itemKebab}>
          <ModalMenuItemUserSuscriber
            item={item}
            setRows={setRows}
            setLoading={setLoading}
            types={types}
            typesComercial={typesComercial}
            setOpenModalDisableUser={setOpenModalDisableUser}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
